const tabNames = [
  'balances',
  'positions',
  'orders',
  'conditionalOrders',
  // 'history',
] as const;

export { tabNames };
